import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import { Row, Col, Form, Table, Modal, Button } from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import moment from "moment";
import { AddButton } from "./AddEditDeleteButton/AddEditDeleteButton";
import { FilterSearchSortDownload } from "./FilterSearchSortDownload/FilterSearchSortDownload";
import { UomTableHead } from "./TableHeadBody/UomTableHead";
import { UomTableBody } from "./TableHeadBody/UomTableBody";
import BasicPagination from "./../../../Pagination/Pagination";
import Alert from "react-s-alert";
import { useFormik } from "formik";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  admin_get_all_uom_ratio,
  admin_uom_ratio_filter_search,
  admin_delete_uom_ratio,
} from "../../../../store/actions/SuperAdminActions/superAdminUOMAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

export const SuperAdminDisplayUomRatio = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userSort, setUserSort] = useState("");
  const [dateQuery, setDateQuery] = useState({
    startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  const token = props.auth.user.accessToken;

  const [page, setPage] = useState(
    props?.managementPage?.page !== undefined ? props?.managementPage?.page : 1
  );
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(
    props?.managementPage?.per_page !== undefined
      ? props?.managementPage?.per_page
      : 10
  );
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    // var calcStart = pageNo * 10 - 10;
    // setStart(calcStart);
    // setEnd(pageNo * 10);
    // setPage(pageNo);
    //page = pageNo;
    dispatch(
      admin_get_all_uom_ratio(
        token,
        pageNo,
        end,
        false,
        dateQuery,
        () => onSuccessPagination(),
        formik.values.status !== "" ? true : false,
        formik.values.major_classification !== "" ? true : false,
        formik.values.status,
        formik.values.major_classification
      )
    );
  };

  const onSuccessPagination = () => {};

  const [unitOfManagement, setUnitOfManagement] = useState([]);
  useEffect(() => {
    dispatch(
      admin_get_all_uom_ratio(token, 1, end, false, dateQuery, () =>
        onSuccessPagination()
      )
    );
  }, []);

  const [state, setState] = useState({
    displaySearch: false,
    displayFilter: false,
    filterApply: false,
    displayDeleteModal: false,
    search: "",
  });

  /***********************************
   * @DESC SEARCH INPUT
   ***********************************/
  const onClickSearch = (e) => {
    e.preventDefault();
    setState({
      ...state,
      displaySearch: !state.displaySearch,
      displayFilter: false,
    });
  };
  const onChangeSearch = (e) => {
    e.preventDefault();
    setState({
      ...state,
      search: e.target.value,
    });
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const userFilter = [
    { title: "A-Z", disabled: false },
    { title: "Z-A", disabled: false },
    { title: `Date & Time 🠑`, disabled: false },
    { title: "Date & Time 🠓", disabled: false },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onClickSetUserSort = (title) => {
    setUserSort(title);
    setAnchorEl(null);
  };

  /***********************************
   * @DESC Date Change Filter Action
   ***********************************/
  const onDateChangeHandler = (data) => {
    setDateQuery(data);
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      // setLoading(true)
      dispatch(
        admin_get_all_uom_ratio(token, page, end, false, dateQuery, () =>
          onSuccessPagination()
        )
      );
    }
  }, [dateQuery]);

  useEffect(() => {
    setUnitOfManagement(props.ratioManagement);
  }, [props.ratioManagement]);

  let filteredData = unitOfManagement && unitOfManagement;
  filteredData =
    filteredData &&
    filteredData.sort(function (a, b) {
      let nameA =
        a && a?.major_classification && a?.major_classification.toLowerCase(); // ignore upper and lowercase
      let nameB =
        b && b?.major_classification && b?.major_classification.toLowerCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });

  if (userSort === "A-Z") {
    filteredData =
      filteredData &&
      filteredData.sort((a, b) => {
        if (
          a?.major_classification?.toLowerCase() <
          b?.major_classification?.toLowerCase()
        )
          return -1;
        if (
          a?.major_classification?.toLowerCase() >
          b?.major_classification?.toLowerCase()
        )
          return 1;
        return 0;
      });
  } else if (userSort === "Z-A") {
    filteredData =
      filteredData &&
      filteredData.sort((a, b) => {
        if (
          a?.major_classification?.toLowerCase() <
          b?.major_classification?.toLowerCase()
        )
          return 1;
        if (
          a?.major_classification?.toLowerCase() >
          b?.major_classification?.toLowerCase()
        )
          return -1;
        return 0;
      });
  } else if (userSort === "Date & Time 🠑") {
    filteredData =
      filteredData &&
      filteredData.sort(
        (a, b) => new Date(a?.updatedAt) - new Date(b?.updatedAt)
      );
  } else if (userSort === "Date & Time 🠓") {
    filteredData =
      filteredData &&
      filteredData.sort(
        (a, b) => new Date(b?.updatedAt) - new Date(a?.updatedAt)
      );
  }

  if (!isEmpty(state.search)) {
    filteredData =
      filteredData &&
      filteredData.filter((item) => {
        return (
          item?.conversion_from_short_code
            ?.toLowerCase()
            .includes(state.search.toLowerCase()) ||
          item?.conversion_to_short_code
            ?.toLowerCase()
            .includes(state.search.toLowerCase()) ||
          item?.major_classification
            .toLowerCase()
            .includes(state.search.toLowerCase())
        );
      });
  }

  const downloadData = {
    headers: [
      { label: "S.No.", key: "serialNo" },
      { label: "Conversion From Short Code", key: "shortCodeF" },
      { label: "Conversion From Value", key: "shortCodeFValue" },
      { label: "Conversion To Short Code", key: "shortCodeT" },
      { label: "Conversion To Value", key: "shortCodeTValue" },
      { label: "Major Classification", key: "majorClassification" },
      { label: "Status", key: "statusData" },
      { label: "Date Time", key: "dateTime" },
    ],
    data: filteredData
      ? filteredData &&
        filteredData?.map((ele, index) => {
          return {
            serialNo: `${
              props?.managementPage?.page * 10 - 10 + 1 + index++ || ""
            }`,
            shortCodeF: `${ele?.conversion_from_short_code || " "}`,
            shortCodeFValue: `${ele?.conversion_from_value || " "}`,
            shortCodeT: `${ele?.conversion_to_short_code || " "}`,
            shortCodeTValue: `${ele?.conversion_to_value || " "}`,
            majorClassification: `${ele?.major_classification || " "}`,
            statusData: `${ele?.status ? "ACTIVE" : "INACTIVE"}`,
            dateTime: `${moment(ele?.createdAt).format("Do MMM YYYY hh:mm A")}`,
          };
        })
      : [],
  };

  /***********************************
   * @DESC DELETE BUTTON Action
   ***********************************/
  const [deleteUomId, setDeleteUomId] = useState("");
  const openCloseDeleteModal = (data) => {
    setState({
      ...state,
      displayDeleteModal: !state.displayDeleteModal,
    });
    setDeleteUomId(data?._id);
  };
  const handleDeleteUom = (deleteUomId) => {
    dispatch(admin_delete_uom_ratio(token, deleteUomId, onSuccessDelete));
  };
  const onSuccessDelete = () => {
    Alert.success(`<h4>Unit Of Measurement Ratio Deleted Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 5000,
      offset: 35,
    });
    setState({
      ...state,
      displayDeleteModal: !state.displayDeleteModal,
    });
    dispatch(
      admin_get_all_uom_ratio(
        token,
        page,
        end,
        false,
        dateQuery,
        () => onSuccessPagination(),
        formik.values.status !== "" ? true : false,
        formik.values.major_classification !== "" ? true : false,
        formik.values.status,
        formik.values.major_classification
      )
    );
  };

  /***********************************
   * @DESC EDIT BUTTON Action
   ***********************************/
  const onEditClickHandler = (data) => {
    history.push({
      pathname: `/superadmin/management-services/editratio/${data?._id}`,
      state: { editState: data, editAction: true },
    });
  };

  /***********************************
   * @DESC FILTER BUTTON ACTION
   ***********************************/
  const onClickShowFilter = (e) => {
    e.preventDefault();
    setState({
      ...state,
      displayFilter: !state.displayFilter,
      displaySearch: false,
    });
  };

  const formik = useFormik({
    initialValues: {
      major_classification: "",
      status: "",
    },
    onSubmit: (values) => {
      let token = props.auth.user.accessToken;
      let formData = {
        major_classification: values.major_classification,
        status: values.status,
      };
      if (formData.major_classification === "" && formData.status === "") {
        Alert.error(
          `<h4>Please fill atleast one of the following filter fields</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 5000,
            offset: 35,
          }
        );
      } else {
        dispatch(
          admin_get_all_uom_ratio(
            token,
            page,
            end,
            false,
            dateQuery,
            () => onSuccessFilterData(),
            formik.values.status !== "" ? true : false,
            formik.values.major_classification !== "" ? true : false,
            formik.values.status,
            formik.values.major_classification
          )
        );
      }
    },
  });

  const onSuccessFilterData = () => {
    setState({
      ...state,
      displayFilter: false,
      filterApply: true,
    });
  };

  const onClickResetFilter = () => {
    dispatch(
      admin_get_all_uom_ratio(
        token,
        page,
        end,
        false,
        dateQuery,
        () => onSuccessResetFilter(),
        false,
        false
      )
    );
  };

  const onSuccessResetFilter = () => {
    setState({
      ...state,
      filterApply: false,
    });
  };

  const [count, setCount] = useState(1);
  const onClickSave = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <Row className="pt-4 pb-3 align-items-center">
                <Col>
                  <div className="f20_700_HelveticaNeue">
                    Unit Of Measurement Ratio
                  </div>
                </Col>
                <Col>
                  <div className="text-right">
                    <AddButton
                      type={"button"}
                      title={"Add UOM Ratio"}
                      buttonText={"Add New"}
                      onClickPress={() =>
                        history.push("/superadmin/management-services/addratio")
                      }
                    />
                  </div>
                </Col>
              </Row>
              <Row className="align-items-center">
                <Col sm={12} md={12} lg={12} xl={12}>
                  <FilterSearchSortDownload
                    searchClick={(e) => onClickSearch(e)}
                    showSearch={state.displaySearch}
                    onSearchChange={(e) => onChangeSearch(e)}
                    searchInput={state.search}
                    /******* Sort Button ******/
                    sortClick={(event) => handleClick(event)}
                    anchorEl={anchorEl}
                    handleClose={() => handleClose}
                    userFilter={userFilter}
                    setUserSort={(title) => onClickSetUserSort(title)}
                    /******* Filter Button ******/
                    showFilter={(e) => onClickShowFilter(e)}
                    /******* Download Button ******/
                    downloadFileName={"Unit Of Management Ratio"}
                    headers={downloadData.headers}
                    data={downloadData.data}
                    /******* Date Filter *******/
                    onDateChangeHandler={onDateChangeHandler}
                  />
                </Col>
                {state.displayFilter ? (
                  <Col sm={12} md={12} lg={12} xl={12}>
                    <Form noValidate onSubmit={(e) => onClickSave(e)}>
                      <Col sm={12} md={12}>
                        <Row
                          className="py-3 bg-white d-flex align-items-center"
                          style={{
                            height: "22vh",
                            boxShadow: "0px 3px 6px #6E6E6E21",
                            borderRadius: 5,
                          }}
                        >
                          <Col sm={4}>
                            <FormControl fullWidth variant="outlined">
                              <InputLabel id="demo-simple-select-label">
                                Major Classification
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="major_classification"
                                name="major_classification"
                                label="Major Classification"
                                className={`w-100`}
                                onChange={formik.handleChange}
                                value={formik.values.major_classification}
                                onBlur={formik.handleBlur}
                              >
                                <MenuItem value="" disabled selected>
                                  Select Major Classification
                                </MenuItem>
                                {props?.majorClassification?.map(
                                  (data, index) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={data.title.toUpperCase()}
                                        name={data.title}
                                      >
                                        {data.title}
                                      </MenuItem>
                                    );
                                  }
                                )}
                              </Select>
                            </FormControl>
                          </Col>
                          <Col sm={4}>
                            <FormControl fullWidth variant="outlined">
                              <InputLabel id="demo-simple-select-label">
                                Status
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="status"
                                name="status"
                                label="Status"
                                className={`w-100`}
                                onChange={formik.handleChange}
                                value={formik.values.status}
                                onBlur={formik.handleBlur}
                              >
                                <MenuItem value="" disabled selected>
                                  Select Status
                                </MenuItem>
                                <MenuItem value="ACTIVE">Active</MenuItem>
                                <MenuItem value="INACTIVE">Inactive</MenuItem>
                              </Select>
                            </FormControl>
                          </Col>
                          <Col
                            sm={12}
                            className={
                              "d-flex align-items-center justify-content-end"
                            }
                          >
                            <Button
                              variant="outline-secondary"
                              className="px-4 py-2 f14-400"
                              style={{
                                borderRadius: 5,
                              }}
                              title="Cancel"
                              onClick={(e) => onClickShowFilter(e)}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="danger"
                              className="px-4 py-2 text-white f14-400 ml-3"
                              style={{
                                borderRadius: 5,
                                backgroundColor: "#EE3A23",
                              }}
                              type="Submit"
                              title="Filter Submit"
                            >
                              Submit
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Form>
                  </Col>
                ) : null}
                {state.filterApply ? (
                  <Col
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={`text-right ${
                      state.displayFilter ? "mt-3" : ""
                    }`}
                  >
                    <Button
                      variant="danger"
                      className="px-4 py-2 text-white"
                      style={{
                        borderRadius: 5,
                        fontSize: 12,
                        backgroundColor: "#EE3A23",
                      }}
                      type="button"
                      title="Reset Filter"
                      onClick={(e) => onClickResetFilter(e)}
                    >
                      Reset Filter
                    </Button>
                  </Col>
                ) : null}
                <div className="col-12 user-table-reusable-superadmin table-responsive">
                  <Table>
                    <UomTableHead
                      serialNo={"S.No."}
                      name={"Major Classification"}
                      code={"Conversation From"}
                      system={"Conversation To"}
                      classification={"Ratio of Conversion"}
                      // classificationTwo={"Classification"}
                      status={"Status"}
                    />
                    <tbody className="sd_body_css text-break">
                      {props.auth.loader ? (
                        <div className="text-center">
                          <Loader
                            type="Bars"
                            color="#00BFFF"
                            height={100}
                            width={100}
                          />
                        </div>
                      ) : filteredData && filteredData.length <= 0 ? (
                        <React.Fragment>
                          <div className="text-center">
                            <h3 className="f16-500 opacity5">
                              NO RECORDS FOUND
                            </h3>
                          </div>
                        </React.Fragment>
                      ) : (
                        !isEmpty(filteredData) &&
                        filteredData?.length > 0 &&
                        filteredData.slice(start, end).map((uom, index) => (
                          <React.Fragment key={index}>
                            <UomTableBody
                              key={index}
                              serialNo={
                                props?.managementPage?.page * 10 -
                                10 +
                                1 +
                                index++
                              }
                              unitName={uom?.major_classification}
                              shortCode={uom?.conversion_from_short_code}
                              uomSystem={uom?.conversion_to_short_code}
                              majorClassification={
                                uom?.conversion_from_value +
                                " : " +
                                uom?.conversion_to_value
                              }
                              status={uom?.status}
                              onChangeStatus={() => {}}
                              onClickDelete={() => openCloseDeleteModal(uom)}
                              onClickEdit={() => onEditClickHandler(uom)}
                            />
                          </React.Fragment>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
                {filteredData && filteredData.length > 0 ? (
                  <BasicPagination
                    totalRecords={props?.managementPage?.total_record}
                    limit={props?.managementPage?.per_page}
                    batch={props?.managementPage?.page}
                    onBatchChange={(e) => handleBatchChange(e)}
                  />
                ) : (
                  <> </>
                )}
              </Row>
            </div>
          </div>
        </Row>
      </div>
      <Modal
        show={state.displayDeleteModal}
        onHide={openCloseDeleteModal}
        centered
      >
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to delete the UOM ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={openCloseDeleteModal}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => handleDeleteUom(deleteUomId)}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

SuperAdminDisplayUomRatio.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  admin_get_all_uom_ratio: PropTypes.func.isRequired,
  admin_uom_ratio_filter_search: PropTypes.func.isRequired,
  admin_delete_uom_ratio: PropTypes.func.isRequired,
  majorClassification: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  ratioManagement: state?.uomRatioManagement?.getAllUomRatio?.data,
  managementPage: state?.uomRatioManagement?.getAllUomRatio,
  majorClassification: state.category.major_classification,
});

export default connect(mapStateToProps, {
  admin_get_all_uom_ratio,
  admin_uom_ratio_filter_search,
  admin_delete_uom_ratio,
})(withRouter(SuperAdminDisplayUomRatio));
